import React, { useEffect } from "react";
import { FaHistory, FaTimes, FaUsers, FaUserShield } from "react-icons/fa";

const getDrawerMeta = (mode, teamMember, user) => {
  if (mode === "team-create") {
    return {
      icon: FaUsers,
      label: "Équipe du club",
      title: "Ajouter un membre",
      subtitle: "Ajoutez une personne visible dans la présentation du club.",
    };
  }

  if (mode === "team-edit") {
    return {
      icon: FaUsers,
      label: "Équipe du club",
      title: "Modifier le membre",
      subtitle: "Mettez à jour la photo, la fonction, la catégorie ou la position.",
    };
  }

  if (mode === "team-details") {
    return {
      icon: FaUsers,
      label: "Équipe du club",
      title: [teamMember?.prenom, teamMember?.nom].filter(Boolean).join(" "),
      subtitle: "Consultez les informations du membre.",
    };
  }

  if (mode === "user-create") {
    return {
      icon: FaUserShield,
      label: "Utilisateurs",
      title: "Créer un utilisateur",
      subtitle: "Ajoutez un accès à l'application d'administration.",
    };
  }

  if (mode === "user-edit") {
    return {
      icon: FaUserShield,
      label: "Utilisateurs",
      title: "Modifier l'utilisateur",
      subtitle: "Mettez à jour l'identité, le rôle ou la photo.",
    };
  }

  if (mode === "user-details") {
    return {
      icon: FaUserShield,
      label: "Utilisateurs",
      title: [user?.prenom, user?.nom].filter(Boolean).join(" "),
      subtitle: "Consultez les informations du compte.",
    };
  }

  if (mode === "history-edit") {
    return {
      icon: FaHistory,
      label: "Historique",
      title: "Modifier l'historique du club",
      subtitle: "Mettez à jour les images, le titre et le texte enrichi.",
    };
  }

  return {
    icon: FaUsers,
    label: "Le club",
    title: "Gestion du club",
    subtitle: "",
  };
};

export default function ClubDrawer({
  open,
  mode,
  teamMember,
  user,
  onClose,
  children,
}) {
  const meta = getDrawerMeta(mode, teamMember, user);
  const Icon = meta.icon;

  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  return (
    <>
      <div
        className={`fixed inset-0 z-40 bg-slate-950/50 backdrop-blur-sm transition-opacity ${
          open
            ? "pointer-events-auto opacity-100"
            : "pointer-events-none opacity-0"
        }`}
        onClick={onClose}
      />

      <aside
        className={`fixed inset-y-0 right-0 z-50 flex w-full max-w-5xl flex-col border-l border-slate-200 bg-white shadow-2xl transition-transform duration-300 dark:border-slate-800 dark:bg-slate-950 ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <header className="border-b border-slate-200 bg-slate-50 px-5 py-5 dark:border-slate-800 dark:bg-slate-900">
          <div className="flex items-start justify-between gap-4">
            <div className="flex min-w-0 gap-3">
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-orange-50 text-orange-600 dark:bg-orange-500/10 dark:text-orange-300">
                <Icon />
              </span>

              <div className="min-w-0">
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-600 dark:text-orange-300">
                  {meta.label}
                </p>
                <h2 className="mt-1 truncate text-xl font-bold text-slate-950 dark:text-white">
                  {meta.title}
                </h2>
                <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                  {meta.subtitle}
                </p>
              </div>
            </div>

            <button
              type="button"
              onClick={onClose}
              className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl border border-slate-200 bg-white text-slate-500 transition hover:border-rose-200 hover:text-rose-600 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-300"
            >
              <FaTimes />
            </button>
          </div>
        </header>

        <div className="min-h-0 flex-1 overflow-y-auto px-5 py-5">
          {children}
        </div>
      </aside>
    </>
  );
}